/**
 * View and filter type constants for Friends/Groups page.
 * Use UPPER_CASE keys for registry/constant objects (Liran's Rules).
 */

export const VIEW_TYPE = {
  FRIENDS: 'FRIENDS',
  GROUPS: 'GROUPS',
} as const

export type ViewType = (typeof VIEW_TYPE)[keyof typeof VIEW_TYPE]

export const FILTER_TYPE = {
  FRIEND: 'FRIEND',
  PENDING: 'PENDING',
  SUGGESTED: 'SUGGESTED',
} as const

export type FilterType = (typeof FILTER_TYPE)[keyof typeof FILTER_TYPE]
